import { Alert, AlertProps, Collapse } from "@mui/material";
import { forwardRef, useImperativeHandle, useState } from "react";

export type DismissableAlertHandle = {
  dismiss: () => void;
};

const DismissableAlert = forwardRef<DismissableAlertHandle, AlertProps>((props, ref) => {
  const [open, setOpen] = useState(true);
  const handleDismiss = () => setOpen(false);

  useImperativeHandle(ref, () => ({
    dismiss() {
      handleDismiss();
    },
  }));

  return (
    <Collapse in={open}>
      <Alert onClose={handleDismiss} {...props} />
    </Collapse>
  );
});

export default DismissableAlert;
